import classNames from 'classnames';
import { Link } from 'react-router-dom';

export interface NavButtonProps {
  title: string;
  buttonClassName?: string;
  iconClassName: string;
  isCurrent?: boolean;
  to?: string;
  onClick?: () => void;
  transitionDurationClass: string;
  isCollapsed: boolean;
}

export function NavButton({
  title,
  buttonClassName,
  iconClassName,
  isCurrent,
  to,
  onClick,
  transitionDurationClass,
  isCollapsed,
}: NavButtonProps) {
  const getContents = () => {
    return (
      <div
        className={classNames(
          buttonClassName,
          'transition-all flex items-center gap-6 hover:bg-light-primary hover:text-white hover:opacity-75',
          transitionDurationClass,
          {
            'mx-3 px-3 my-2 py-2 rounded-xl justify-center': isCollapsed,
            'px-6 py-4 rounded-2xl': !isCollapsed,
          },
          {
            'bg-light-primary text-white shadow': isCurrent,
            'text-neutral-600': !isCurrent,
          }
        )}
      >
        <i className={classNames('fa-solid w-6', iconClassName, 'text-2xl')} />
        {isCollapsed ? null : (
          <div className="text-lg font-semibold">{title}</div>
        )}
      </div>
    );
  };

  return (
    <li
      className={classNames('h-16', transitionDurationClass, {
        'w-[252px]': !isCollapsed,
        'w-[80px]': isCollapsed,
      })}
    >
      {!!to && <Link to={to}>{getContents()}</Link>}
      {!!onClick && <button onClick={onClick}>{getContents()}</button>}
    </li>
  );
}

export default NavButton;
